import { Box, Text, Flex } from "orcs-design-system";
import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import styled from "styled-components";
import themeGet from "@styled-system/theme-get";

const ChatHistoryItem = styled(Box)`
  cursor: pointer;
  padding: ${themeGet("space.s")};
  padding-right: ${themeGet("space.r")};
  border-radius: ${themeGet("radii.2")};
  &.active {
    background-color: ${themeGet("colors.primaryLightest")};
  }
`;

const formatChatDate = (dateString) => {
  const date = new Date(parseInt(dateString, 10));
  return moment(date).fromNow();
};

const getChatPreview = (chat) => {
  if (!chat.title) {
    return "New chat";
  }

  return chat.title.length > 50
    ? `${chat.title.substring(0, 50)}...`
    : chat.title;
};

const ChatHistoryPanel = ({
  chats,
  currentChatId,
  onSelectChat,
  loading,
  isFullPage,
}) => {
  if (loading) {
    return (
      <Box
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        padding="m"
      >
        <Text color="greyMedium">Loading chat history...</Text>
      </Box>
    );
  }

  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      flexDirection="column"
      background="white"
      borderRight={isFullPage ? "none" : "1px solid"}
      borderRightColor="greyLighter"
    >
      {/* Chat List */}
      <Box flex={1} overflow="auto">
        {chats?.length === 0 ? (
          <Box padding="m" textAlign="center">
            <Text color="greyMedium" fontSize="0.875">
              No chat history yet
            </Text>
          </Box>
        ) : (
          <Box p={isFullPage ? "0" : "s"}>
            <Flex flexDirection="column" gap="s">
              {chats?.map((chat) => (
                <ChatHistoryItem
                  key={chat.id}
                  padding="s"
                  px="r"
                  cursor="pointer"
                  className={currentChatId === chat.id ? "active" : ""}
                  onClick={() => onSelectChat(chat.id)}
                >
                  <Flex gap="xs" alignItems="center" width="100%">
                    <Text lineHeight="1.3">{getChatPreview(chat)}</Text>
                    <Text
                      minWidth="115px"
                      fontSize="0.75"
                      ml="auto"
                      textAlign="right"
                      color="grey"
                    >
                      {formatChatDate(chat.updatedAt)}
                    </Text>
                  </Flex>
                </ChatHistoryItem>
              ))}
            </Flex>
          </Box>
        )}
      </Box>
    </Box>
  );
};

ChatHistoryPanel.propTypes = {
  chats: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      updatedAt: PropTypes.string.isRequired,
      createdAt: PropTypes.string.isRequired,
      messages: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          role: PropTypes.string.isRequired,
          content: PropTypes.string.isRequired,
          createdAt: PropTypes.string.isRequired,
        })
      ),
    })
  ),
  currentChatId: PropTypes.string,
  onSelectChat: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  isFullPage: PropTypes.bool,
};

export default ChatHistoryPanel;
